import { render } from "./SharePoint_EstimationPage.vue?vue&type=template&id=ea7c4c70"
import script from "./SharePoint_EstimationPage.vue?vue&type=script&lang=js"
export * from "./SharePoint_EstimationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__